/** Production site origin — single source of truth for canonical URLs, JSON-LD, sitemap. */
export const SITE_ORIGIN = 'https://sushiking.com.pl'

export const SITE_EMAIL = 'kontakt@sushiking.com.pl'

/** Absolute URL for a path (e.g. `/menu` → `https://sushiking.com.pl/menu`). */
export function siteUrl(path = '/'): string {
    if (!path || path === '/') return `${SITE_ORIGIN}/`
    const normalized = path.startsWith('/') ? path : `/${path}`
    return `${SITE_ORIGIN}${normalized}`
}
